var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMenuAvatar = function SvgMenuAvatar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0001,
    cy: 20,
    r: 14.9998,
    fill: "#0875E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1354 26.2438C25.7394 23.9711 24.5689 22.2622 22.025 21.677C21.6056 21.5794 21.4671 21.041 21.8065 20.7738C22.6298 20.1241 23.2131 19.0687 23.3633 17.8319C23.5915 15.9435 22.3489 14.0825 20.4371 13.7996C18.2619 13.4758 16.3872 15.1281 16.3872 17.2038C16.3872 18.7039 17.0193 20.0129 17.9752 20.7699C18.3165 21.0391 18.1858 21.5794 17.7625 21.677C15.2167 22.2622 14.0462 23.9692 13.6502 26.2438",
    stroke: "white",
    strokeWidth: 1.53409,
    strokeMiterlimit: 10
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMenuAvatar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "menu_avatar.ab9cbd8d373a3214fea2b9beb22c35a8.svg";